import React, { useEffect, useState } from "react";
import "./planos-Style.css";

const ProductCard = ({ title, subtitle, description, images, buttonLabel }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  // Troca automática de imagem
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % images.length);
    }, 2000); // troca a cada 2 segundos
    return () => clearInterval(interval);
  }, [images.length]);

  // Número do WhatsApp
  const whatsappNumber = "5511970874083";

  // Extrai o nome do plano (antes do " - ")
  const planoNome = title.split(" - ")[0];

  // Mensagem personalizada
  const mensagem = encodeURIComponent(
    `Olá! Gostaria de saber mais sobre o plano ${title} ${subtitle} do DK Coworking.`
  );

  // Link do WhatsApp
  const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${mensagem}`;

  return (
    <div className="card">
      <div className="card__image-holder">
        <img
          src={images[currentIndex]}
          alt={title}
          className="card__image"
        />
      </div>
      <div className="card__content">
        <div className="card__title">{title}</div>
        <div className="card__title">{subtitle}</div>
        <p className="card__text">{description}</p>
        <a
          href={whatsappUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="btn btn--block card__btn"
        >
          {buttonLabel}
        </a>
      </div>
    </div>
  );
};

export default ProductCard;
